export const environment = {
    production: true,
    gtmId: 'GTM-PXC88W5W'
};
